"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { ShoppingBag, User, Sparkles } from "lucide-react"
import { useAuthStore } from "@/lib/auth-store"
import Image from "next/image"


export function FirstLoginModal() {
  const [isOpen, setIsOpen] = useState(false)
  const { isAuthenticated, user } = useAuthStore()

  useEffect(() => {
    // Check if this is the first login
    const hasSeenWelcome = localStorage.getItem("luxury-jeff-welcome-seen")

    if (isAuthenticated && !hasSeenWelcome) {
      setIsOpen(true)
    }
  }, [isAuthenticated])

  const handleChoice = (choice: "shop" | "profile") => {
    localStorage.setItem("luxury-jeff-welcome-seen", "true")
    setIsOpen(false)

    if (choice === "profile") {
      window.location.href = "/profile"
    } else {
      window.location.href = "/shop"
    }
  }

  if (!isAuthenticated || !user) return null

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="text-center">
            <div className="flex items-center justify-center mx-auto mb-4">
              {/* <Sparkles className="h-8 w-8 text-white" /> */}
              <Image src="/logo.png" alt="" width={150}
                height={50}
                className="rounded-lg" />
            </div>

            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Hi {user.firstName}! Thanks for joining us. What would you like to do first?
            </p>
          </div>
        </DialogHeader>

        <div className="space-y-3 mt-6">
          <Button
            onClick={() => handleChoice("shop")}
            className="w-full bg-gradient-to-r from-[#ea580c] to-[#d97706] hover:from-[#dc2626] hover:to-[#ea580c] text-white h-12"
          >
            <ShoppingBag className="h-5 w-5 mr-2" />
            Start Shopping
          </Button>

          <Button onClick={() => handleChoice("profile")} variant="outline" className="w-full h-12">
            <User className="h-5 w-5 mr-2" />
            Go to My Account
          </Button>
        </div>

        <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-4">
          You can always access your account from the user icon in the header.
        </p>
      </DialogContent>
    </Dialog>
  )
}
